var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSheetContentAmenities',{attrs:{"title":_vm.unitName,"features":_vm.unitFeaures,"enter-to":_vm.unitAccessRouterLinks.default,"tour360-to":_vm.unitAccessRouterLinks.tour360}})
}
var staticRenderFns = []

export { render, staticRenderFns }